import React from 'react'

export default function ErrorBadge({message}) {
  return (
    <div className='text-red-600 bg-red-500/[.4] text-center m-2 rounded-xl p-5'>
        {message}
    </div>
  )
}
